import { create } from 'zustand';

interface GlobalLoadingState {
  isLoading: boolean;
  message: string;
  showLoading: (message?: string) => void;
  hideLoading: () => void;
}

export const useGlobalLoading = create<GlobalLoadingState>((set) => ({
  isLoading: false,
  message: '处理中...',
  showLoading: (message = '处理中...') => set({ isLoading: true, message }),
  hideLoading: () => set({ isLoading: false }),
}));